var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExciting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7153 10.8132L2.20322 21.2174L0 19.0368L10.5121 8.63257L12.7153 10.8132Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7963 39.5956L31.2842 49.9998L29.081 47.8192L39.5931 37.415L41.7963 39.5956Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5648 41.4393L17.5878 35.1418C17.5753 35.1101 17.5606 35.0774 17.5454 35.0436C17.5411 35.034 17.5368 35.0243 17.5324 35.0145C17.161 34.2845 16.3484 33.9169 15.5663 34.0795C15.727 33.3142 15.343 32.5294 14.6055 32.1618L8.13373 27.151L9.02663 26.5182C9.19807 26.398 9.41772 26.3768 9.61238 26.4616L15.9609 29.2861C16.0252 29.3373 16.0949 29.3868 16.1699 29.431C16.9985 29.9206 18.0771 29.6696 18.5968 28.8584C21.0148 25.0671 24.1346 20.7898 27.3776 16.813C27.983 16.0706 27.874 14.996 27.1436 14.3739C27.0615 14.3032 26.974 14.2431 26.8847 14.19L11.9375 2.78094L14.2715 0.896809C14.7734 0.492056 15.4555 0.389538 16.0556 0.633451L33.4172 7.67333C34.1154 8.22655 35.1316 8.18766 35.7834 7.55844C42.2873 1.26091 47.3536 -1.32138 49.3466 0.647589C51.3342 2.61656 48.7251 7.63445 42.3641 14.0734C41.7265 14.7185 41.6873 15.7277 42.2498 16.4171L49.3609 33.597C49.6073 34.1891 49.5037 34.866 49.0948 35.3627L47.1911 37.6728L35.7227 22.9532C35.6602 22.8348 35.5834 22.7217 35.4905 22.6138C34.8619 21.8909 33.7672 21.7937 33.0154 22.3911C29.0027 25.5974 24.6792 28.6851 20.8451 31.0801C20.0308 31.5891 19.7968 32.6319 20.2844 33.4556C20.3058 33.4927 20.329 33.528 20.354 33.5652L23.2649 39.9811C23.3506 40.1667 23.3274 40.3876 23.2059 40.5556L22.5648 41.4393ZM47.6947 38.3215L47.6965 38.3241C47.696 38.3232 47.6956 38.3223 47.6947 38.3215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExciting);
export default __webpack_public_path__ + "static/media/exciting.1cb8a866bf181f6a32fe714758aa49d2.svg";
export { ForwardRef as ReactComponent };